import axios from './templateInstance'
import { SaveDesignTemplateRequest } from '@/types/designTemplate'

/** Creates when no id is given, replaces when one is. */
const saveDesignTemplate = async (request: SaveDesignTemplateRequest, id?: string | null) => {
  const response: any = id
    ? await axios.put(`/design-templates/${id}`, request)
    : await axios.post(`/design-templates/`, request)

  return response?.data ?? response
}

export default saveDesignTemplate
